import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import styles from './SiteNav-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
};

const SiteNavDropdownColumn = ({ items, trackingLabelPrefix }) => (
    <div className={styles.dropdownCol}>
        {items.map(item => (
            <div key={item.serviceId} className={styles.dropdownSection}>
                {item.name ? <div className={styles.dropdownHeader}>{item.name}</div> : null}
                {(item.items || []).map(({ url, name, serviceId, isLinkable }) => {
                    const label = `${trackingLabelPrefix}|${item.name}|${name}`;
                    return (
                        <div key={serviceId}>
                            <a
                                className={styles.dropdownLink}
                                href={url}
                                onClick={() => {
                                    trackEvent(
                                        Object.assign({}, trackingObj, {
                                            label: label.toLowerCase(),
                                        })
                                    );
                                }}
                                data-tn={`global-nav-item-link-${label
                                    .toLowerCase()
                                    .replace(/[^a-zA-Z0-9]+/gi, '-')}`}
                                rel={isLinkable ? null : 'nofollow'}
                            >
                                {name}
                            </a>
                        </div>
                    );
                })}
            </div>
        ))}
    </div>
);

SiteNavDropdownColumn.propTypes = {
    items: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
};

export default SiteNavDropdownColumn;
